import React from 'react';
import { GenericFormModal } from './GenericFormModal';
import { AwardFormFields } from '../forms/AwardFormFields';

export function AwardFormModal({ 
  isOpen, 
  onClose, 
  award,
  onSubmit
}) {
  const [localFormData, setLocalFormData] = React.useState(award || {
    name: '',
    date: '',
    location: ''
  });

  // Update localFormData when award prop changes
  React.useEffect(() => {
    if (award) {
      setLocalFormData(award);
    } else {
      setLocalFormData({
        name: '',
        date: '',
        location: ''
      });
    }
  }, [award, isOpen]);

  const handleChange = ({ target }) => {
    const { name, value } = target;
    setLocalFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await onSubmit(e, localFormData);
      onClose();
    } catch (error) {
      console.error('AwardFormModal submit error:', error);
      // Modal bleibt offen bei Fehler
    }
  };

  return (
    <GenericFormModal 
      isOpen={isOpen} 
      onClose={onClose}
      title={award ? 'Award bearbeiten' : 'Neuer Award'}
      size="xl"
    >
      <AwardFormFields
        formData={localFormData}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        isEdit={!!award}
      />
    </GenericFormModal>
  );
}